/* eslint-disable no-use-before-define */
import { ajax, arrayFrom, parseDate, fmt } from '../twd/twd'

export const getCalcOutput = async ({cusip, priceYield, priceOrYield, action, qty, settlement}) => {
    if (!cusip) return null

    const settleDt = parseDate(settlement)
    if (!settleDt) return null

    const {data} = ajax({
        url: '/esb/retailservice/calculator/calculate',
        method: 'POST',
        params: {
            cusip,
            priceYield,
            priceOrYield,
            action,
            qty,
            settlement: fmt.mdy(settleDt)
        }
    })

    const calc = await data

    calc.priceYields = arrayFrom(calc.priceYields)
        .sort(({price:a},{price:b}) => a - b)

    calc.paymentsFirstYear = arrayFrom(calc.paymentsFirstYear)

    calc.paymentsByYears = arrayFrom(calc.paymentsByYears)
        .map(r => ({...r, date: parseDate(r.year)}))

    return calc
}



// WEBPACK FOOTER //
// ./src/calculator/get-calc-output.js